// @flow

import React from 'react';
import type { Node } from 'react';
import { Row, Col } from '@riseart/antd-provider';
import { ArtistArtGridArt } from 'shared_components/cms/modules/artist/ArtGridArt';
import { ArtistArtGridArtist } from 'shared_components/cms/modules/artist/ArtGridArtist';
import { ArtistArtGridText } from 'shared_components/cms/modules/artist/ArtGridText';

import { cmsModuleArtistArtGridRowCls } from 'shared_components/cms/modules/artist/ArtGrid.less';

type Props = {
  rows?: ?Array<{
    gutter?: number,
    verticalAlign?: 'top' | 'middle' | 'bottom',
    columns: Array<{
      contentType: string,
      content: Object,
      contentText: Object,
      width?: number,
    }>,
  }>,
  disableHeadingTags?: boolean,
  lazyload?: Object,
};

/**
 * CmsModuleArtistArtGrid
 *
 * @param {Props} props
 * @returns {Node}
 */
export function CmsModuleArtistArtGrid({ rows = null, disableHeadingTags }: Props): Node {
  const CONTENT_TYPE = { TEXT: 'text', ART: 'art', ARTIST: 'artist' };
  const VERTICAL_ALIGN = { top: 'top', middle: 'middle', bottom: 'bottom' };

  return rows && rows.length
    ? rows.map(({ gutter, verticalAlign, columns }, idx) => {
        const totalColumns = (columns && columns.length) || 0;

        return totalColumns ? (
          <Row
            key={idx}
            type="flex"
            justify="start"
            align={(verticalAlign && VERTICAL_ALIGN[verticalAlign]) || VERTICAL_ALIGN.top}
            gutter={[gutter ? parseInt(gutter, 10) : 8, gutter ? parseInt(gutter, 10) : 8]}
            className={cmsModuleArtistArtGridRowCls}
          >
            {columns.map(({ content, contentType, contentText, width }, idx) =>
              contentType && (content || contentText) ? (
                <Col
                  key={idx}
                  xs={24}
                  sm={24}
                  md={[null, undefined].indexOf(width) === -1 ? parseInt(width, 10) : 24}
                >
                  {(contentType === CONTENT_TYPE.TEXT && contentText && (
                    // Text Content
                    <ArtistArtGridText text={contentText} />
                  )) ||
                    (contentType === CONTENT_TYPE.ARTIST && content && (
                      // Artist Content
                      <ArtistArtGridArtist
                        id={content.id}
                        alias={content.alias}
                        name={content.name}
                        text={contentText}
                        disableHeadingTags={disableHeadingTags}
                      />
                    )) ||
                    (contentType === CONTENT_TYPE.ART && content && (
                      // Art Content
                      <ArtistArtGridArt
                        art={content}
                        artDirectionSize={
                          (totalColumns === 1 && 'grid.cmsEditorialOneCol') ||
                          (totalColumns === 2 && 'grid.cmsEditorialTwoCol') ||
                          'grid.cmsEditorialThreeCol'
                        }
                      />
                    )) ||
                    null}
                </Col>
              ) : null,
            )}
          </Row>
        ) : null;
      })
    : null;
}
